const fr = {
  app_title: 'TidjarAI',
  app_subtitle: 'Votre assistant intelligent pour l\'importation en Algérie 🇩🇿',
  app_desc: 'Identifiez instantanément le code douanier (SH) de vos produits, calculez les droits et taxes à l\'import (DD, TVA, TCS, DAPS) selon la réglementation algérienne en vigueur, et obtenez la checklist complète des documents requis pour le dédouanement.',
  app_desc2: 'Générez votre Programme Prévisionnel d\'Importation (PPI) au format officiel du Ministère du Commerce, téléchargez votre checklist en PDF, et envoyez directement à votre fournisseur la liste des documents à préparer.',
  app_desc3: 'Conçu pour les importateurs algériens, transitaires et PME. Conforme au tarif douanier DGD, accords préférentiels (UE, GZALE), et formalités du Ministère du Commerce (mcepe.gov.dz).',
  app_tip: '💡 Analysez vos produits un par un, retrouvez les codes SH dans l\'historique 🕐, puis basculez sur l\'onglet PPI pour créer votre programme prévisionnel multi-produits — le tout sans changer de page.',
  feat1_title: 'Classification IA',
  feat1_desc: 'Identification automatique du code SH parmi +15 000 positions du tarif douanier algérien grâce à l\'intelligence artificielle.',
  feat2_title: 'Calcul fiscal DGD',
  feat2_desc: 'DD, TVA, TCS, DAPS, TDB — formule officielle de la Direction Générale des Douanes avec accords préférentiels.',
  feat3_title: 'Documents & PPI',
  feat3_desc: 'Checklist personnalisée, PPI au format officiel mcepe.gov.dz, et email fournisseur bilingue FR/EN.',
  feat4_title: 'Accords commerciaux',
  feat4_desc: 'Détection automatique EUR.1 (UE), GZALE (zone arabe), accords bilatéraux — avec calcul des économies.',
  history: 'Historique',
  history_title: 'Historique des analyses',
  history_empty: 'Aucune analyse précédente.',
  form_title: 'Analyser une importation',
  form_description: 'Description du produit',
  form_description_ph: 'Ex: câbles électriques, chocolat, peinture, blé tendre...',
  form_country: 'Pays du fournisseur',
  form_country_ph: '— Sélectionner —',
  form_activity: 'Code activité RC',
  form_activity_ph: '— Sélectionner —',
  form_price: 'Prix estimé (optionnel)',
  form_price_ph: 'Montant',
  form_currency: 'Devise',
  form_incoterm: 'Incoterm',
  btn_analyze: 'Analyser mon importation',
  btn_analyzing: 'Analyse en cours...',
  btn_reset: 'Nouvelle analyse',
  btn_copy: 'Copier l\'email',
  btn_copied: 'Copié !',
  error_not_found: 'Produit non reconnu. Essayez une description plus précise (ex: "câbles électriques", "ciment Portland", "chocolat").',
  section_classification: 'Classification tarifaire',
  section_documents: 'Checklist documentaire',
  section_etiquetage: 'Règles d\'étiquetage obligatoires',
  section_calcul: 'Estimation des droits et taxes',
  section_economies: 'Alertes économies',
  section_email: 'Email fournisseur',
  section_downloads: 'Téléchargements',
  section_ppi: 'Créer un PPI (Programme Prévisionnel d\'Importation)',
  docs_fournisseur: 'Documents fournisseur (avant expédition)',
  docs_importateur: 'Documents importateur (avant arrivée)',
  code_sh: 'Code SH',
  confiance: 'Confiance',
  description: 'Description',
  chapitres: 'Chapitres SH',
  dd: 'Droits de Douane',
  tva: 'TVA',
  tcs: 'TCS',
  daps: 'DAPS',
  daps_warning: 'Ce produit est soumis au DAPS. Cette taxe protectionniste s\'applique même aux produits UE bénéficiant de 0% DD.',
  accord: 'Accord',
  document: 'Document',
  recommande: 'Recommandé',
  autorisation: 'Autorisation préalable',
  valeur_cif: 'Valeur CIF (DZD)',
  total_taxes: 'Total taxes',
  cout_total: 'Coût total rendu',
  taux_change: 'Taux de change utilisé',
  comparateur_title: 'Comparaison avec / sans accord préférentiel',
  avec_accord: 'Avec accord',
  sans_accord: 'Sans accord',
  economie_accord: 'Économie avec accord',
  download_pdf: 'Checklist PDF',
  download_excel: 'Excel PPI (mcepe.gov.dz)',
  download_email: 'Copier email fournisseur',
  disclaimer_title: 'Avertissement de validité',
  disclaimer_extra: 'Les documents supplémentaires peuvent être exigés selon l\'inspection douanière, la wilaya concernée, ou des circulaires récentes.',
  footer: 'Cet outil ne se substitue pas à un conseil juridique ou douanier professionnel.',
  // PPI
  ppi_intro: 'Remplissez les informations de votre entreprise et ajoutez les produits que vous souhaitez importer.',
  ppi_raison_sociale: 'Raison Sociale',
  ppi_rc: 'Registre de Commerce',
  ppi_nif: 'NIF',
  ppi_tel: 'Téléphone',
  ppi_email: 'Email',
  ppi_lignes: 'Lignes du programme',
  ppi_position: 'Position Tarifaire',
  ppi_sous_position: 'Sous-Position',
  ppi_designation: 'Désignation du produit',
  ppi_stock: 'État des Stocks (30/06)',
  ppi_quantite: 'Quantité',
  ppi_unite: 'Unité',
  ppi_observations: 'Observations',
  ppi_add_line: 'Ajouter une ligne',
  ppi_download_pdf: 'Télécharger PDF',
  ppi_download_excel: 'Télécharger Excel',
  act_01: '01 — Industrie',
  act_07: '07 — Services',
  act_04: '04 — Négoce',
  act_nesda: 'NESDA',
  lang_fr: 'Français',
  lang_ar: 'العربية',
};

const ar = {
  app_title: 'TidjarAI',
  app_subtitle: 'مساعدك الذكي للاستيراد في الجزائر 🇩🇿',
  app_desc: 'حدد فوراً الرمز الجمركي (SH) لمنتجاتك، احسب الرسوم والضرائب عند الاستيراد (DD، TVA، TCS، DAPS) وفقاً للتنظيم الجزائري الساري، واحصل على القائمة الكاملة للوثائق المطلوبة للتخليص الجمركي.',
  app_desc2: 'أنشئ برنامجك التقديري للاستيراد (PPI) بالصيغة الرسمية لوزارة التجارة، حمّل قائمة الوثائق بصيغة PDF، وأرسل مباشرة لموردك قائمة الوثائق الواجب تحضيرها.',
  app_desc3: 'مصمم للمستوردين الجزائريين، وكلاء الجمارك والمؤسسات الصغيرة والمتوسطة. مطابق للتعريفة الجمركية للمديرية العامة للجمارك، الاتفاقيات التفضيلية (الاتحاد الأوروبي، المنطقة العربية)، وإجراءات وزارة التجارة (mcepe.gov.dz).',
  app_tip: '💡 حلل منتجاتك واحداً تلو الآخر، استرجع رموز SH من السجل 🕐، ثم انتقل إلى تبويب PPI لإنشاء برنامجك التقديري متعدد المنتجات — كل ذلك دون تغيير الصفحة.',
  feat1_title: 'تصنيف بالذكاء الاصطناعي',
  feat1_desc: 'تحديد تلقائي لرمز النظام المنسق من بين أكثر من 15,000 بند في التعريفة الجمركية الجزائرية.',
  feat2_title: 'حساب جبائي رسمي',
  feat2_desc: 'الرسوم الجمركية، TVA، TCS، DAPS، TDB — الصيغة الرسمية للمديرية العامة للجمارك مع الاتفاقيات التفضيلية.',
  feat3_title: 'الوثائق والبرنامج التقديري',
  feat3_desc: 'قائمة وثائق مخصصة، برنامج تقديري بالصيغة الرسمية mcepe.gov.dz، وبريد المورد ثنائي اللغة.',
  feat4_title: 'الاتفاقيات التجارية',
  feat4_desc: 'كشف تلقائي لـ EUR.1 (الاتحاد الأوروبي)، المنطقة العربية الحرة، الاتفاقيات الثنائية — مع حساب التوفير.',
  history: 'السجل',
  history_title: 'سجل التحليلات',
  history_empty: 'لا توجد تحليلات سابقة.',
  form_title: 'تحليل عملية استيراد',
  form_description: 'وصف المنتج',
  form_description_ph: 'مثال: كابلات كهربائية، شوكولاتة، دهان، قمح...',
  form_country: 'بلد المورد',
  form_country_ph: '— اختر —',
  form_activity: 'رمز النشاط التجاري',
  form_activity_ph: '— اختر —',
  form_price: 'السعر التقديري (اختياري)',
  form_price_ph: 'المبلغ',
  form_currency: 'العملة',
  form_incoterm: 'شرط التسليم',
  btn_analyze: 'تحليل عملية الاستيراد',
  btn_analyzing: 'جاري التحليل...',
  btn_reset: 'تحليل جديد',
  btn_copy: 'نسخ البريد',
  btn_copied: 'تم النسخ!',
  error_not_found: 'منتج غير معروف. حاول وصفاً أكثر دقة.',
  section_classification: 'التصنيف الجمركي',
  section_documents: 'قائمة الوثائق المطلوبة',
  section_etiquetage: 'قواعد الوسم الإلزامية',
  section_calcul: 'تقدير الرسوم والضرائب',
  section_economies: 'تنبيهات التوفير',
  section_email: 'بريد المورد',
  section_downloads: 'التحميلات',
  section_ppi: 'إنشاء البرنامج التقديري للاستيراد',
  docs_fournisseur: 'وثائق المورد (قبل الشحن)',
  docs_importateur: 'وثائق المستورد (قبل الوصول)',
  code_sh: 'رمز النظام المنسق',
  confiance: 'الثقة',
  description: 'الوصف',
  chapitres: 'الفصول',
  dd: 'الرسوم الجمركية',
  tva: 'الرسم على القيمة المضافة',
  tcs: 'رسم التضامن',
  daps: 'الرسم الإضافي المؤقت',
  daps_warning: 'هذا المنتج خاضع للرسم الإضافي المؤقت. يُطبق حتى على منتجات الاتحاد الأوروبي.',
  accord: 'الاتفاقية',
  document: 'الوثيقة',
  recommande: 'موصى به',
  autorisation: 'ترخيص مسبق',
  valeur_cif: 'القيمة CIF (د.ج)',
  total_taxes: 'إجمالي الضرائب',
  cout_total: 'التكلفة الإجمالية',
  taux_change: 'سعر الصرف المستخدم',
  comparateur_title: 'مقارنة مع / بدون اتفاقية تفضيلية',
  avec_accord: 'مع اتفاقية',
  sans_accord: 'بدون اتفاقية',
  economie_accord: 'التوفير مع الاتفاقية',
  download_pdf: 'تحميل PDF',
  download_excel: 'تحميل Excel',
  download_email: 'نسخ بريد المورد',
  disclaimer_title: 'تحذير بشأن الصلاحية',
  disclaimer_extra: 'قد تُطلب وثائق إضافية حسب التفتيش الجمركي أو الولاية المعنية.',
  footer: 'هذه الأداة لا تغني عن الاستشارة القانونية أو الجمركية المهنية.',
  ppi_intro: 'املأ معلومات مؤسستك وأضف المنتجات التي ترغب في استيرادها.',
  ppi_raison_sociale: 'التسمية الاجتماعية',
  ppi_rc: 'رقم السجل التجاري',
  ppi_nif: 'رقم التعريف الجبائي',
  ppi_tel: 'الهاتف',
  ppi_email: 'البريد الإلكتروني',
  ppi_lignes: 'خطوط البرنامج',
  ppi_position: 'البند التعريفي',
  ppi_sous_position: 'البند الفرعي',
  ppi_designation: 'تعيين المنتوج',
  ppi_stock: 'حالة المخزونات (30/06)',
  ppi_quantite: 'الكمية',
  ppi_unite: 'الوحدة',
  ppi_observations: 'ملاحظات',
  ppi_add_line: 'إضافة سطر',
  ppi_download_pdf: 'تحميل PDF',
  ppi_download_excel: 'تحميل Excel',
  act_01: '01 — صناعة',
  act_07: '07 — خدمات',
  act_04: '04 — تجارة',
  act_nesda: 'NESDA',
  lang_fr: 'Français',
  lang_ar: 'العربية',
};

export const translations = { fr, ar };
export const t = (lang, key) => translations[lang]?.[key] || translations.fr[key] || key;
